import { KYMW6802Component } from './kymw6802.component';

/**
 * ECカテゴリ変換マスタ一覧表画面の値を管理するクラス
 *
 * @export KYMW6802Model
 * @class KYMW6802Model
 */
export class KYMW6802Model {

  kymw6802Component: KYMW6802Component;

  // ファイル名
  public fileName: string = null;
  // カテゴリ区分
  public categoryDiv: string = <string>'';
  // カテゴリコード
  public categoryCode: string = <string>'';
  public convDiv: string = <string>'';
  public markCode: string = <string>'';
  public radioGroup: string = <string>'';
  public pageNum: string = <string>'';
  public exhibitionDiv: string = <string>'';
  public pricePattern: string = <string>'';
  public mediumType: string = <string>'';
  public featureCode: string = <string>'';
  public proDiv: string = <string>'';
  public proInfo: string = <string>'';
  public tag1: string = <string>'';
  public tag2: string = <string>'';


  /**
   * ファイル名を更新する
   *
   * @param {*} serverData ファイル名のサーバ取得データ
   * @memberof KYMW6802Model
   */
  public updateFileName(serverData: any): void {
    this.fileName = serverData.FileName;
  }

}
